import { guardClient } from '../_axios'

const API_USERS = '/users'
/**
 * ユーザー情報の更新
 * @param request
 * @returns
 */
export type UpdateUserRequestType = {
  userId: string
  authorityCode: 'GENERAL' | 'ADMIN'
  version: string
}
export const updateUser = async (request: UpdateUserRequestType) => {
  const { userId, ...rest } = request
  const response = await guardClient.patch(`${API_USERS}/${userId}`, rest)
  return response.data
}
